import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const ChecklistIcon = ({ fill = 'white', width = 18, height = 18 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 15 18"
        fill="none"
    >
        <path
            d="M10.6908 1.5C10.5174 1.06186 10.1979 0.68262 9.77591 0.414129C9.35394 0.145638 8.85011 0.00100312 8.33333 0L6.66667 0C6.14989 0.00100312 5.64606 0.145638 5.22408 0.414129C4.80211 0.68262 4.48257 1.06186 4.30917 1.5H0V15.75C0 16.9905 1.12167 18 2.5 18H12.5C13.8783 18 15 16.9905 15 15.75V1.5H10.6908ZM3.65667 6.52875L4.72333 7.4385L6.84667 5.52825L8.025 6.58875L5.78167 8.60775C5.50801 8.85647 5.13676 8.9985 4.74788 9.00327C4.35899 9.00804 3.98359 8.87516 3.7025 8.63325L2.51083 7.61775L3.65667 6.52875ZM4.7275 13.5037C4.36083 13.5037 3.9925 13.3807 3.7025 13.1332L2.51083 12.1177L3.65667 11.0287L4.72333 11.9385L6.84667 10.0283L8.025 11.0887L5.78167 13.1077C5.64375 13.2332 5.47958 13.3328 5.29864 13.4007C5.11769 13.4687 4.92357 13.5037 4.7275 13.5037ZM11.6667 13.5H7.5L9.20167 12H11.6667V13.5ZM11.6667 9H7.5L9.20167 7.5H11.6667V9Z"
            fill={fill}
        />
    </svg>
);
